import React from 'react';
import {render} from 'react-dom';
import {Provider} from 'react-redux';

import {createStore} from '../utils/redux';

import reducer from './reducer';

import AirportList from './components/AirportList';
import ControlsArea from './components/ControlsArea';

const ControlsAreaNode = document.getElementById('controls-area');
const ContentNode = document.getElementById('content');

const store = createStore(reducer, 'METAR/TAF');

render(
    <Provider store={store}>
        <ControlsArea />
    </Provider>,
    ControlsAreaNode,
);

render(
    <Provider store={store}>
        <AirportList />
    </Provider>,
    ContentNode,
);
